export const baseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost"
    : "https://slareporter.hofstaete.nl";
